/**
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
export default function downloadCsv(data, filename, mime_type, bom = null) {
  if (bom !== null) {
    data = [bom, data]
  } else {
    data = [data]
  }
  const blob = new Blob(data, { type: mime_type })
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, filename)
  } else {
    const blobURL = window.URL.createObjectURL(blob)
    const tempLink = document.createElement('a')
    tempLink.style.display = 'none'
    tempLink.href = blobURL
    tempLink.setAttribute('download', filename)

    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank')
    }

    document.body.appendChild(tempLink)
    tempLink.click()
    document.body.removeChild(tempLink)
    window.URL.revokeObjectURL(blobURL)
  }
}
